// 两类报价共用微单位换算、计费类型和北京时间生效时间校验（D110、D111）。
import type { ChargeOn } from "@/app/master";
import type { Errors } from "@/app/useDraft";
import { CURRENCY_ERROR, fromLocalInput, parseMoney, validCurrency, validMcc, validMnc } from "@/app/form";

/** 客户和供应商报价共有的六个字段。 */
export interface PricingFieldsDraft { mcc: string; mnc: string; price: string; currency: string; charge_on: ChargeOn; effective_from: string }

/** 把报价草稿转换为 API 字段，同时保留六位价格精度和 MNC 前导零；MCC、MNC 与路由条件同一格式（#463）。 */
export function pricingInput(d: PricingFieldsDraft) {
  const errors: Errors<PricingFieldsDraft> = {};
  const price = parseMoney(d.price);
  const from = fromLocalInput(d.effective_from);
  if (!["submitted", "delivered"].includes(d.charge_on)) errors.charge_on = "选择提交或送达。";
  if (!validMcc(d.mcc)) errors.mcc = "三位数字。";
  if (d.mnc && !validMnc(d.mnc)) errors.mnc = "两到三位数字，留空表示全部运营商。";
  if (price == null || price < 0) errors.price = "非负金额，最多 6 位小数。";
  if (!validCurrency(d.currency)) errors.currency = CURRENCY_ERROR;
  if (!from) errors.effective_from = "填写生效时间（北京时间）。";
  if (Object.keys(errors).length || price == null || !from) return { errors };
  return { errors, body: { charge_on: d.charge_on, mcc: d.mcc, mnc: d.mnc || null, price, currency: d.currency, effective_from: from } };
}
